import { useMutation } from "@tanstack/react-query";
import { api } from "../../libs/axios";

export function useMutationMail() {
  return useMutation({
    retry: false,
     mutationFn: async ({id}: {id: string}) => {
      const response = await api.post(`/pedido/mail/${id}`);

      return response.data;
    },
  });
}